import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import axios from "../api/axios";

const StoreContext = createContext();
export const useStore = () => useContext(StoreContext);

export const StoreProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ Loading state


  const categoriesWithProducts = useMemo(() => {
    if (!categories.length || !products.length) return [];
    return categories.filter(cat =>
      products.some(p => p.category_id === cat.id && p.stock > 0)
    );

  }, [categories, products]);


  const fetchProducts = useCallback(async () => {
    try {
      const response = await axios.get("/api/products");
      setProducts(response.data.data);
    } catch (error) {
      console.error("🔥 Error fetching products:", error.message);
    }
  }, [setProducts]); // ✅ Memoized now

  const fetchCategories = async () => {
    try {
      const response = await axios.get("/api/products/categories");
      setCategories(response.data.data);
    } catch (error) {
      console.error("🔥 Error fetching categories:", error.message);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true); // Start loading
      await Promise.all([fetchProducts(), fetchCategories()]);
      setLoading(false); // Done loading
    };
    loadData();
  }, [fetchProducts]);

  return (
    <StoreContext.Provider 
      value={{ 
        products, 
        categories: categoriesWithProducts, 
        fetchProducts, 
        loading 
      }}>
      {children}
    </StoreContext.Provider>
  );
};